module.exports = __webpack_public_path__ + "img/MB.9e3ec755.png";